import { useEffect } from "react";
import Staff from '../table/Tablestaff';
import Modal from "../modal/Modalstaff"



const Dashboard = () => {
  useEffect(() => {
    // getPromise(["sales", "purchases"]);
  }, []);


  return (
    <>
    <Modal/>
    <Staff/>
    
     
     </>
  );
};

export default Dashboard;
